<div class="full-height" data-bs-theme="light">

    <div #sidebar id="sidebar" >

    </div>

    <div #fireforesight id="fireforesight" class="leaflet-sidebar-pane"  data-bs-theme="light">
        <h1 class="leaflet-sidebar-header">
            Fire Foresight
            <div class="leaflet-sidebar-close"><i class="fa fa-caret-left"></i></div>
        </h1>
        <div>
            <ul *ngIf="fire.cameras">
                <li *ngFor="let status of fire.visibleStatusTypes" class="menu-item">
                    <h3 (click)="toggleFireForesight(status)">{{status.displayName}}</h3>
                    <ul>
                        <li *ngFor="let incident of fire.incidents | incidentpipe:status.statusId" class="menu-item">
                            <div class="form-check form-switch" (click)="toggleFireIncident(incident)">
                                <input type="checkbox" class="form-check-input" id="newEnabled" [(ngModel)]="incident.shown">
                                <label class="form-check-label" for="newEnabled">#{{incident.incidentId}} {{incident.confidence}}% {{incident.site.name}}</label>
                            </div>  
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>

    <div #sites id="sites" class="leaflet-sidebar-pane"  data-bs-theme="light">
        <h1 class="leaflet-sidebar-header">
            Layers
            <div class="leaflet-sidebar-close"><i class="fa fa-caret-left"></i></div>
        </h1>
        <div>
            <h2><i class="fa fa-map-marker"></i> Sites</h2>
            <ul>
                <li *ngFor="let site of siteTypes" class="menu-item">
                    <div class="form-check form-switch" (click)="toggleSite(site)">
                        <input type="checkbox" class="form-check-input" id="newEnabled" [ngModel]="site.shown">
                        <label class="form-check-label" for="newEnabled">{{site.siteTypeCode}}</label>
                    </div>
                </li>
            </ul>
            <h2><i class="bi bi-stack"></i> Layers</h2>
            <ul *ngIf="mapLayers && mapLayers.children">
                <li *ngFor="let l1 of mapLayers.children" class="menu-item">
                    <h3>{{l1.layerName}}</h3>
                    <ul>
                        <li *ngFor="let l2 of l1.children" class="menu-item">
                            <div class="form-check form-switch" (click)="toggleLayer(l2)">
                                <input type="checkbox" class="form-check-input" id="newEnabled" [ngModel]="l2.shown">
                                <label class="form-check-label" for="newEnabled">{{l2.layerName}}</label>
                            </div>  
                            <!--<button *ngIf="l2.url" class="btn btn-sm btn-outline-primary" (click)="toggleLayer(l2)" [ngClass]="{'selected':l2.layer}">{{l2.layerName}}</button>-->
                        </li>
                    </ul>
                </li>
            </ul>
            <!--<ul *ngFor="let layer of layers.children">
                <li *ngIf="layer.children == null && layer.url">
                    <button class="btn btn-sm btn-white" (click)="toggleLayer(layer)" [ngClass]="{'selected':layer.layer}">{{layer.layerName}}</button>
                </li>
                <li>
                    <h3>layer.layerName</h3>
                    <ul *ngIf="layer.children && layer.url == null" class="header d-flex fw-bold small mb-3">
                        <span class="flex-grow-1">{{layer.layerName}}</span>
                    
                        <li *ngFor="let layer1 of layer.children">
                            <div *ngIf="layer1.children == null && layer1.url">
                                <button class="btn btn-sm btn-white" (click)="toggleLayer(layer1)" [ngClass]="{'selected':layer1.layer}">{{layer1.layerName}}</button>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>-->
            
        </div>
    </div>

    <div #layers id="layers" class="leaflet-sidebar-pane">
        <h1 class="leaflet-sidebar-header">
            Layers
            <div class="leaflet-sidebar-close"><i class="fa fa-caret-left"></i></div>
        </h1>
            <div *ngIf="layers && layers.children">
                <ul *ngFor="let layer of layers.children">
                    <li *ngIf="layer.children == null && layer.url">
                        <button class="btn btn-sm btn-white" (click)="toggleLayer(layer)" [ngClass]="{'selected':layer.layer}">{{layer.layerName}}</button>
                    </li>
                    <ul *ngIf="layer.children && layer.url == null" class="header d-flex fw-bold small mb-3">
                        <span class="flex-grow-1" [title]="layer.type">{{layer.layerName}}</span>
                    
                        <li *ngFor="let layer1 of layer.children">
                            <div *ngIf="layer1.children == null && layer1.url">
                                <button class="btn btn-sm btn-white" (click)="toggleLayer(layer1)" [ngClass]="{'selected':layer1.layer}">{{layer1.layerName}}</button>
                            </div>
                        </li>
                    </ul>
                </ul>
            </div>

    </div>
    
    <div id="sidebar" class="leaflet-sidebar leaflet-sidebar-right" [ngClass]="{'full-screen':fullScreen}" [hidden]="selectedSite == null">
        <!-- Nav tabs -->
        <div class="leaflet-sidebar-tabs" role="tablist">
            <ul class="">
                <li class="active" title="Layers">
                    <a (click)="toggle()">
                        <i *ngIf="!fullScreen" class="fa fa-expand"></i>
                        <i *ngIf="fullScreen" class="fa fa-compress"></i>
                    </a>
                </li>
            </ul>
        </div>
    
        <!-- Tab panes -->
        <div class="leaflet-sidebar-content">
            <div class="leaflet-sidebar-pane active">
                <h1 class="leaflet-sidebar-header" *ngIf="selectedSite">
                    {{selectedSite.siteType}}
                    <div (click)="closeSite()" class="leaflet-sidebar-close">
                        <i class="fa fa-caret-right"></i>
                    </div>
                </h1>

                <div *ngIf="selectedSite && selectedSite.siteType && selectedSiteType">
                    <div class="data-panel-detail">
                        <h3>{{selectedSite.siteName}}</h3>
                        <div>{{selectedSite.siteDescription}}</div>
                    </div>

                    <div [ngSwitch]="selectedSiteType.displayMode">
                        <div *ngSwitchDefault>
                            <table width="100%" *ngIf="!this.fullScreen">
                                <thead>
                                    <tr>
                                        <td width="50%">Parameter</td>
                                        <td width="50%">Value</td>
                                    </tr>
                                </thead>
                                <tr *ngFor="let ts of selectedSite.parameters | keyvalue">
                                    <td *ngIf="ts.value.hidden == false">{{ts.value.name}}</td>
                                    <td *ngIf="ts.value.hidden == false">{{ts.value?.latestValue.value | number}} {{ts.value.units}}</td>
                                </tr>
                            </table>

                            <div dropdown *ngIf="!fullScreen && selectedSiteType.dashboards && selectedSiteType.dashboards.length > 0" class="btn-group form-group-sm">
                                <button id="button-basic" dropdownToggle class="btn btn-sm btn-outline-primary" aria-controls="dropdown-basic">
                                    Dashboards
                                    <i class="fa fa-sort-asc"></i>
                                </button>
                                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                                    <li role="menuitem" *ngFor="let dashboard of selectedSiteType.dashboards">
                                        <a class="dropdown-item" [href]="'/#/dashboard/' + dashboard.dashboardId + '/' + selectedSite.siteUri">{{dashboard.name}}</a>
                                    </li>
                                </ul>
                            </div>
                            <div *ngIf="fullScreen">
                                <dashboard-tabs [siteType]="selectedSiteType" [siteUri]="selectedSite?.siteUri"></dashboard-tabs>
                            </div>                            
                        </div>
                        <div *ngSwitchCase="3">
                            <app-fire-camera-viewer [siteTwin]="selectedSite" [fullScreen]="fullScreen"></app-fire-camera-viewer>
                        </div>                        
                        <div *ngSwitchCase="2">
                            <app-fire-camera-viewer [siteTwin]="selectedSite" [fullScreen]="fullScreen"></app-fire-camera-viewer>
                        </div>
                        <!--<div *ngSwitchCase="1">
                            <app-weather-station-viewer [siteTwin]="selectedSite" [fullScreen]="fullScreen"></app-weather-station-viewer>
                        </div>-->
                        <div *ngSwitchCase="'Fire Incident'">
                            HERE
                            <app-fire-foresight-incident-embedded [incidentId]="selectedSite.incident.incidentId" [fullScreen]="fullScreen"></app-fire-foresight-incident-embedded>
                        </div>
                    </div>
                    
                </div>

                <div *ngIf="selectedSite && selectedSite.siteType == null">
                    <!-- TAS ALERTS -->
                    <div class="data-panel-detail" *ngIf="selectedSite.properties != null && selectedSite.properties.type != null">
                        <h3><img [src]="'/assets/icons/' + selectedSite.properties.type.eventIcon + '.svg'" class="icon"/> {{selectedSite.properties.title}}</h3>
                        <div *ngIf="selectedSite.properties.address"><i class="bi bi-pin-map-fill"></i> {{selectedSite.properties.address}}</div>
                        <div *ngIf="selectedSite.properties.number"><i class="bi bi-hash"></i> {{selectedSite.properties.number}}</div>
                        <div *ngIf="selectedSite.properties.status"><i class="bi bi-list-task"></i> {{selectedSite.properties.status}}</div>            
                        <div *ngIf="selectedSite.properties.bodyHtml && fullScreen" [innerHtml]="selectedSite.properties.bodyHtml" ></div>            
                    </div>
                    <!-- WA Emergency -->
                    <div class="data-panel-detail" *ngIf="selectedSite.properties != null && selectedSite.properties.entityType != null">
                        <h3 class="pb-2">
                            <img *ngIf="selectedSite.properties['incident-icon'] == null" [src]="'/assets/icons/waemergency/' + selectedSite.properties?.['geo-source']?.features?.[0]?.properties?.['icon-name'] + '.svg'" class="icon"/> 
                            <img *ngIf="selectedSite.properties['incident-icon']" [src]="'/assets/icons/waemergency/' + selectedSite.properties['incident-icon'] + '.svg'" class="icon"/>
                            {{selectedSite.properties.name}}</h3>
                        <h4 class="pb-2">{{selectedSite.properties["warning-type"]}} {{selectedSite.properties["headline"]}}</h4>
                        <h5 class="pb-2" *ngIf="selectedSite.properties.updatedAt">Updated: {{selectedSite.properties.updatedAt | date:'d/M/yy h:mm a'}}</h5>
                        <div *ngIf="selectedSite.properties.location && selectedSite.properties.location.value"><i class="bi bi-pin-map-fill"></i> {{selectedSite.properties.location.value}}</div>
                        
                        <div [innerHTML]='selectedSite.properties["what-to-do-note"]'></div>
                         
                    </div>
                </div>

                
            </div>
        </div>
    </div>

    <app-map #streetMap [style]="'height:200px'" [mapheight]="'100%'" [mapType]="'googleStreets'" (mapInitComplete)="mapReadyForInit($event)"></app-map>
    
</div>